import {Component, DestroyRef, effect, inject, OnDestroy, OnInit, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {combineLatest, Subscription} from 'rxjs';
import {TuningsService} from "../../service/Tunings.service";
import {ActivatedRoute} from "@angular/router";
import {AttachmentService} from "../../service/attachment.service";


@Component({
    selector: 'app-master-version-details',
    templateUrl: './master-version-details.component.html',
    styleUrls: ['./master-version-details.component.css']
})
export class MasterVersionDetailsComponent implements OnInit, OnDestroy {

    public versionService = inject(TuningsService);
    route = inject(ActivatedRoute);
    private attachmentService = inject(AttachmentService);
    expandedAttachmentIndex = signal<number | null>(null);
    attachmentCounts = signal<Map<number, number>>(new Map());
    readonly focusedVersionId = signal<number | null>(null);
    private destroyRef = inject(DestroyRef);
    private versionRequest?: Subscription;
    private loadedMasterId: number | null = null;

    private versionsEffect = effect(() => {
        const versions = this.versionService.allVersions();
        if (versions.length > 0) {
            this.loadAttachmentCounts(versions);
        }
    });

    ngOnInit() {
        combineLatest([this.route.params, this.route.queryParams])
            .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(([params, query]) => {
                const versionId = Number(query['versionId']);
                this.focusedVersionId.set(Number.isSafeInteger(versionId) && versionId > 0 ? versionId : null);
                this.versionService.versionName.set(query['versionName'] ?? '');
                const masterId = Number(params['id']);
                if (!Number.isSafeInteger(masterId) || masterId <= 0 || masterId === this.loadedMasterId) return;
                this.loadedMasterId = masterId;
                this.versionRequest?.unsubscribe();
                this.versionService.masterId.set(masterId);
                this.versionService.allVersions.set([]);
                this.expandedAttachmentIndex.set(null);
                this.versionRequest = this.versionService.getVersionRecords(masterId);
            });
    }

    ngOnDestroy(): void { this.versionRequest?.unsubscribe(); }

    deleteTuningRecordFromTable(versionId: number, tableName: string) {
        this.versionService.deleteTuningRecordFromTable(versionId, tableName)
    }

    openPureOriginalsByVersionId(versionId: number, versionName: string, dcf: string) {
        this.versionService.getPureOriginalsByVersionId(versionId, versionName, dcf);
    }

    openPartiallyTunePureOriginalsByVersionId(versionId: number, versionName: string, dcf: string) {
        this.versionService.getPartiallyTunePureOriginalsByVersionId(versionId, versionName, dcf);
    }

    openAllPossibleMatchingsByVersionId(versionId: number, versionName: string, dcf: string) {
        this.versionService.getAllPossibleMatchingsByVersionId(versionId, versionName, dcf);
    }

    isDownloadInProgress(id: number) {
        return this.versionService.isDownloadInProgress(id);
    }

    downloadMasterVersion(id: number, winOls: string, versionName: string) {
        this.versionService.getDownloadMasterVersion(id, winOls, versionName);
    }

    onEditVersionComment(index: number) {
        this.versionService.onEditVersionComment(index)
    }

    saveVersionComment(editedItemId: number) {
        this.versionService.saveVersionComment(editedItemId);
    }

    closeEditMode() {
        this.versionService.closeEditMode();
    }

    toggleAttachments(index: number) {
        const wasOpen = this.expandedAttachmentIndex() === index;
        this.expandedAttachmentIndex.update((current) =>
            current === index ? null : index
        );
        if (wasOpen) {
            const versions = this.versionService.allVersions();
            const version = versions[index];
            if (version) {
                this.refreshCountForVersion(+version.id);
            }
        }
    }

    private loadAttachmentCounts(versions: { id: any }[]) {
        versions.forEach((v) => {
            const versionId = +v.id;
            this.attachmentService.listAttachments('version', versionId).subscribe({
                next: (attachments) => {
                    this.attachmentCounts.update((m) => {
                        const updated = new Map(m);
                        updated.set(versionId, attachments.length);
                        return updated;
                    });
                }
            });
        });
    }

    private refreshCountForVersion(versionId: number) {
        this.attachmentService.listAttachments('version', versionId).subscribe({
            next: (attachments) => {
                this.attachmentCounts.update((m) => {
                    const updated = new Map(m);
                    updated.set(versionId, attachments.length);
                    return updated;
                });
            }
        });
    }
}





